import { useEffect } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './api/queryClient';
import { AuthProvider } from './contexts/AuthContext';
import { BrandingProvider } from './contexts/BrandingContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { ToastProvider } from './contexts/ToastContext';
import { TourProvider } from './contexts/TourContext';
import { CookieConsent } from './components/feedback/CookieConsent';
import { AppRouter } from './router';
import { captureUtm } from './utils/utm';
import { getFingerprint } from './utils/fingerprint';
import { trackSiteVisit } from './utils/trackEvent';

function App() {
  useEffect(() => {
    captureUtm();
    getFingerprint().then(() => {
      // Track site visit once per page load — excludes /i/* invite viewer paths
      if (!window.location.pathname.startsWith('/i/')) {
        trackSiteVisit();
      }
    });
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <BrandingProvider>
        <ThemeProvider>
          <AuthProvider>
            <ToastProvider>
              <TourProvider>
                <AppRouter />
                <CookieConsent />
              </TourProvider>
            </ToastProvider>
          </AuthProvider>
        </ThemeProvider>
      </BrandingProvider>
    </QueryClientProvider>
  );
}

export default App;
